import {
  LIST_ALL_SCHEDULE_EXPECTATION_CYCLES_QUERY_KEY,
  LIST_SCHEDULE_EXPECTATION_CYCLES_QUERY_KEY
} from '@/constants/scheduleExpectations';
import useAPI from '@/hooks/useAPI';
import AppointmentsRepository from '@/repositories/AppointmentsRepository';
import ScheduleExpectationRepository from '@/repositories/ScheduleExpectationRepository';
import { QueryParams } from '@/types/query';

export const useAvailableAppointmentTypeOptions = (
  { enabled = true }: { enabled?: boolean } = { enabled: true },
  phaseId: string
) => {
  const scheduleExpectationRepository = ScheduleExpectationRepository();

  return useAPI({
    queryKey: ['listAppointmentTypeOptions', phaseId],
    queryFn: async () => {
      return await scheduleExpectationRepository.listAppointmentTypeOptions({ phaseId });
    },
    enabled
  });
};

export const useAppointmentTypeOptions = (params: QueryParams = {}) => {
  const appointmentsRepository = AppointmentsRepository();

  return useAPI({
    queryKey: ['getAppointmentTypes', params],
    queryFn: async () => {
      return await appointmentsRepository.getAppointmentTypes(params);
    }
  });
};

export const useGroupAppointmentTypeOptions = () => useAppointmentTypeOptions({ is_group: true });

export const useAppointmentTypeScheduleExpectationCyclesWithinLookahead = (phaseId: string) => {
  const scheduleExpectationRepository = ScheduleExpectationRepository();

  return useAPI({
    queryKey: [LIST_SCHEDULE_EXPECTATION_CYCLES_QUERY_KEY, phaseId],
    queryFn: async () => {
      return await scheduleExpectationRepository.listAppointmentTypeScheduleExpectationCyclesWithinLookahead(
        { phaseId }
      );
    },
    staleTime: 5 * 60 * 1000
  });
};

export const useUnexpectedAppointments = (phaseId: string) => {
  const scheduleExpectationRepository = ScheduleExpectationRepository();

  return useAPI({
    queryKey: ['getUnexpectedAppointments', phaseId],
    queryFn: async () => {
      return await scheduleExpectationRepository.getUnexpectedAppointments({ phaseId });
    },
    staleTime: 5 * 60 * 1000
  });
};

export const useAllAppointmentTypeScheduleExpectationCycles = (phaseId: string) => {
  const scheduleExpectationRepository = ScheduleExpectationRepository();

  return useAPI({
    queryKey: [LIST_ALL_SCHEDULE_EXPECTATION_CYCLES_QUERY_KEY, phaseId],
    queryFn: async () => {
      return await scheduleExpectationRepository.listAllAppointmentTypeScheduleExpectationCycles({
        phaseId
      });
    },
    staleTime: 5 * 60 * 1000
  });
};

export default {};
